import clsx from 'clsx'
import React from 'react'

type ChipProps = {
  label: string
  className?: string
}

export const Chip: React.FC<ChipProps> = ({ label, className }) => (
  <span
    className={clsx(
      'border border-solid border-grey-200 px-2 py-1 text-060 uppercase text-grey-900',
      className
    )}
  >
    {label}
  </span>
)
